import { NavigationExtras } from '@angular/router';
import { createActionGroup } from '@ngrx/store';

export {
  ROUTER_REQUEST,
  ROUTER_NAVIGATION,
  ROUTER_NAVIGATED,
  ROUTER_CANCEL,
  ROUTER_ERROR,
} from '@ngrx/router-store';

export const CoreRouterActions = createActionGroup({
  source: '[ Core / Router ]',
  events: {
    'Go To Route': (
      path: string | URL,
      options?: NavigationExtras & { external?: boolean },
    ) => ({
      path,
      options,
    }),
    Navigate: (
      commands: any[],
      options?: NavigationExtras & { external?: boolean },
    ) => ({
      commands,
      options,
    }),
    'Redirect To': (path: string) => ({
      path,
    }),
  },
});
